import React from 'react';
import { Table, Spin } from 'antd';
import { columns } from '../utils/helper';
import type { PolicyType } from '../utils/types';
import { POLICY_TITLE, POLICY_CONTENT } from '../utils/const';
import PopOverMenu from '../components/popover';
import { SummaryTitle } from '../utils/styles';

interface SummaryTableProps {
  policyList?: PolicyType[];
}

export const SummaryTable = (prop: SummaryTableProps) => {
  const { policyList } = prop;
  if (!policyList) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin tip="Loading policy data..." />
      </div>
    );
  }

  const totalRequests = policyList.reduce((sum: number, policy: PolicyType) => {
    return sum + (policy.requests_per_policy || 0);
  }, 0);

  const maxRequests = Math.max(...policyList.map((row) => row.requests_per_policy || 0));

  const formatNumberShort = (num: number): string => {
    if (isNaN(num) || num <= 0) return '—';
    if (num >= 1e9) return (num / 1e9).toFixed(1) + 'B';
    if (num >= 1e6) return (num / 1e6).toFixed(1) + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(1) + 'k';
    return num.toString();
  };

  const updatedColumn = [
    ...(columns ?? []).map((col: any) => {
      if ('dataIndex' in col && col.dataIndex === 'requests_per_policy') {
        return {
          ...col,
          render: (text: string) => {
            const value = Number(text);
            if (isNaN(value)) return null;

            const formatted = formatNumberShort(value);
            const rawPercent = totalRequests > 0 && value > 0 ? (value / totalRequests) * 100 : 0;
            const percent = rawPercent > 0 ? `(${rawPercent.toFixed(1)}%)` : '';
            const barWidth = maxRequests > 0 ? (value / maxRequests) * 100 : 0;

            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 120, whiteSpace: 'nowrap' }}>
                  {formatted} <span style={{ color: '#999' }}>{percent}</span>
                </div>
                {value > 0 && (
                  <div
                    style={{
                      flexGrow: 1,
                      height: 6,
                      backgroundColor: '#f0f0f0',
                      borderRadius: 4,
                      overflow: 'hidden',
                      minWidth: 40,
                      maxWidth: 200,
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: `${barWidth}%`,
                        backgroundColor: '#1890ff',
                      }}
                    />
                  </div>
                )}
              </div>
            );
          },
        };
      }
      return col;
    }),
  ];

  return (
    <div>
      <SummaryTitle>All Policies</SummaryTitle>

      {/* <Card style={{ padding: 0, borderRadius: 8 }}> */}
      <PopOverMenu summary={POLICY_TITLE} content={POLICY_CONTENT} />
      <Table
        style={{ marginRight: 40 }}
        columns={updatedColumn}
        dataSource={policyList}
        rowKey="id"
        bordered={false} // optional, since it's false by default
        size="small"
        pagination={false}
      />
      {/* </Card> */}
    </div>
  );
};
